import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { useIsMobile } from 'src/hooks/useIsMobile'
import {
  defaultRatingTab,
  getRatingTabSelector,
  isLoadingSwimlanesViews
} from 'src/redux-api-bridge/orders-swimlanes/selectors'
import { currentTabIndexSelector } from 'src/redux-api-bridge/calendar/selectors'
import TabButton from 'src/pages/orders/components/Header/Tabs/TabButton'
import { TRatingTab } from 'src/pages/orders/components/RatingTab/RatingTab'
import { TLoadingIndicator } from 'src/pages/orders/components/RatingTab/components/LoadingIndicator/LoadingIndicator'
import './RatingTabButton.scss'

type RatingTabButtonProps = {
  onClick?: Function
  withoutTitle?: boolean
  withIcon?: boolean
}

export const ratingTabIndex = -1

export const RatingTabButton = ({
  onClick,
  withoutTitle = false,
  withIcon = true
}: RatingTabButtonProps) => {
  const isMobile = useIsMobile()
  const ratingTab: TRatingTab | TLoadingIndicator = useSelector(
    getRatingTabSelector
  )
  const isLoadingRatingTab: boolean = useSelector(isLoadingSwimlanesViews)
  const currentTabIndex = useSelector(currentTabIndexSelector)

  const ratingTabTitle = isLoadingRatingTab
    ? defaultRatingTab.props.header.title
    : (ratingTab as TRatingTab)?.props?.header?.title
  const hasMealsToRate =
    !isLoadingRatingTab &&
    (ratingTab as TRatingTab)?.props?.hasMealsToRate === true

  const handleOnClick = useCallback(
    () => (onClick ? onClick(ratingTabIndex) : undefined),
    [onClick]
  )
  const isSelected = currentTabIndex === ratingTabIndex

  return (
    <TabButton
      className={classnames('rating-tab-button', {
        'empty-state': !hasMealsToRate
      })}
      label={withoutTitle ? undefined : ratingTabTitle}
      onClick={onClick ? handleOnClick : undefined}
      isSelected={isSelected}
      withIcon={withIcon}
      isIconFilled={hasMealsToRate || (isMobile && isSelected)}
    />
  )
}
